import styled from 'styled-components';

export const Wrapper = styled.div`
  height: calc(100% - 60px);
  position: fixed;
  right: 60px;
  top: 60px;
  width: 500px;
  z-index: 2000;
  background-color: ${props => props.theme.themeColors.sidebars.background};
  border-left: 1px solid
    ${({ theme }) => theme.themeColors.controlBar.borderBottomColor};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  justify-content: space-between;
  transition: background-color ${({ theme }) => theme.backgroundTransitionTime}
    ease;
  @media all and (max-width: 1200px) {
    width: calc(50% - 60px);
  }
`;

export const WrapperLoad = styled.div`
  height: calc(100% - 60px);
  position: fixed;
  right: 60px;
  top: 60px;
  width: 500px;
  z-index: 2000;
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.themeColors.sidebars.background};
  border-left: 1px solid
    ${({ theme }) => theme.themeColors.controlBar.borderBottomColor};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  justify-content: center;
  transition: background-color ${({ theme }) => theme.backgroundTransitionTime}
    ease;
`;

export const StyledHeader = styled.div`
  align-items: center;
  background: ${({ theme }) =>
    theme.themeColors.sidebars.bookmarks.headerBackground};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  min-height: 40px;
  overflow: hidden;
`;

export const StyledBody = styled.div`
  height: calc(100% - 40px);
  overflow-y: auto;
`;

export const StyledBodyLoad = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props =>
  props.active
    ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
    : props.theme.themeColors.sidebars.thumbnails.textColor};
  height: calc(100% - 40px);
  overflow-y: auto;
`;

export const DocCard = styled.div`
  background: ${props => props.theme.themeColors.controlBar.background};
  margin: 10px;
  display: grid;
  height: 64px;
  &:hover {
    background-color: rgba(106,160,241,0.1);
  }
  position: relative;
`;

export const DocItem = styled.div`
  display: grid;
  grid-template-columns: 50px 1fr;
  height: 64px;
  &:hover {
    background-color: rgba(106,160,241,0.1);
    cursor: pointer;
  }
`;

export const Text = styled.div`
  color: ${props =>
  props.active
    ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
    : props.theme.themeColors.sidebars.thumbnails.textColor};
  margin-bottom: 5px;
  margin-top: 5px;
  &:nth-child(2) {
    color: ${props =>
    props.active
      ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
      : props.theme.themeColors.sidebars.thumbnails.textColor};
    font-size: 14px;
  }
  white-space: nowrap;
  max-width: 350px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const IconBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextBlock = styled.div`  
  display: flex;
  align-items: center;
  margin-right: 64px;
  gap: 0;
`;

export const DropdownContainer = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 50%;
  &:hover {
    background-color: rgba(106,160,241,0.1);
  }
  top: 12px;
  right: 12px;
`;

export const DropdownButton = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Dropdown = styled.ul`
    background: ${props => props.theme.themeColors.controlBar.background};
    box-shadow: rgba(0,0,0,.03) 0px -1px 0px inset, rgba(0,0,0,.2) 0px 1px 3px;    
    list-style: none;
    padding: 0px;
    margin: 0px;
    width: 200px;
    position: absolute;
    top: calc(-100% - 2px);
    right: 0px;   
    z-index: 3001;
`;

export const DropdownItem = styled.li`
    color: ${props =>
      props.active
        ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
        : props.theme.themeColors.sidebars.thumbnails.textColor}; 
    padding: 10px 5px;
    display: flex;
    align-items: center;
    gap: 6px;
    z-index: 400;
    cursor: pointer;
    &:hover {
      background-color: rgba(106,160,241,0.1);
    }
`;

export const UpdateModal = styled.div`
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    z-index: 4000 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    @media all and (max-width: 500px) {
      display: block; 
    }
`;

export const UpdateModalBody = styled.div`
    width: 400px;
    background-color: #ffffff;
    padding: 30px;
    & h2 {
      margin-top: 0px;
    }
    @media all and (max-width: 500px) {
      height: 100%; 
    }
`;

export const UpdateModalFooter = styled.div`
    text-align: right;
`;

export const UpdateModalInput = styled.input`
    padding: 10px;
    background-color: #ffffff;
    border: 1px solid #000000;
    border-radius: 5px;
    width: 100%;
    margin-bottom: 20px;
`;

export const UpdateModalBtnWhite = styled.button`
  padding: 10px 20px;
  background-color: rgba(255,255,255,0.5);
  border-radius: 5px;
  color: #000000;
  border: 1px solid #dedede;
  cursor: pointer;
  transition-duration: 200ms;
  &:hover {
    transition-duration: 200ms;
    background-color: rgba(23, 125, 214, 0.2);    
  }
`;

export const UpdateModalBtn = styled.button`
  padding: 10px 20px;
  background-color: rgb(23, 125, 214);
  border-radius: 5px;
  color: #ffffff;
  border: 1px solid #dedede;
  cursor: pointer;
  margin-left: 10px;
  transition-duration: 200ms;
  &:hover {
    transition-duration: 200ms;
    opacity: 0.8;
  }
`;